<template>
  <div class="input-suggestion">
    <input
      v-model="search"
      type="text"
      v-if="!value"
      :placeholder="placeholder || null"
      @focus="initialSuggestion"
      @input="searchEvent"
    />

    <div
      class="input-selected"
      v-else
    >
      <slot ref="selected" name="selected"></slot>
      <i
        ref="reset"
        class="ico--reset-data"
        @click="clear"
      >
      </i>
    </div>

    <ul
      class="suggestion-list"
      v-show="focused"
    >
      <slot name="suggestion"></slot>
    </ul>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'input-suggestion',

  props: [
    'value',
    'placeholder'
  ],

  data () {
    return {
      search: '',
      focused: false,
      selected: null
    }
  },

  created () {
    this.$on('selected', (message) => {
      this.$emit('input', message)
      this.focused = false
    })
  },

  methods: {
    clear () {
      this.$emit('input', null)
    },

    initialSuggestion () {
      this.focused = true
      this.$emit('search', this.value)
    },

    searchEvent: _.debounce(function (e) {
      this.$emit('search', this.search)
    }, 300)
  }
}
</script>
